module.exports = __webpack_public_path__ + "static/img/10.76919d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/10.png
// module id = j14j
// module chunks = 0